import { useRef, useEffect } from 'react'
import { CompositeDecorator, ContentBlock } from 'draft-js'

import style from '@aytm/app/stats/components/text-editor/TextEditor.module.scss'

let linkDecoratorComponentID = 0
const linkDecoratorComponentIDPrefix = `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`

const linkDecorators = (charsMap: { [char: string]: { text: string; title?: string } }, charsRegexp: RegExp) => {
  const LinkComponent = (props: { decoratedText: string; children: React.ReactNode }) => {
    const title = charsMap[props.decoratedText]?.title
    const idRef = useRef<number>(null)
    if (null === idRef.current) {
      idRef.current = linkDecoratorComponentID++
    }
    const id = `annotation-link-decorator-${linkDecoratorComponentIDPrefix}-${idRef.current}`
    const titleStyle = title ? `#${id}::before { content: "${title}"; }` : ''
    const titleStyleRef = useRef<HTMLStyleElement>(null)
    useEffect(() => {
      if (titleStyleRef.current) {
        titleStyleRef.current.innerText = titleStyle
      }
    }, [titleStyle])
    return (
      <>
        <style ref={titleStyleRef} />
        <span className={style.linkDecorator} id={id}>
          <span className={style.linkDecoratorAnchor}>{props.children}</span>
        </span>
      </>
    )
  }

  return [
    new CompositeDecorator([
      {
        strategy: (
          contentBlock: ContentBlock,
          callback: (start: number, end: number) => void
          /*,_contentState: unknown */
        ) => {
          const text = contentBlock.getText()
          let matchArr
          let start
          while ((matchArr = charsRegexp.exec(text)) !== null) {
            start = matchArr.index
            callback(start, start + matchArr[0].length)
          }
        },
        component: LinkComponent
      }
    ])
  ]
}

export default linkDecorators
